<template lang="pug">
canvas(ref="canvas")
</template>

<script>
import QRCode from 'qrcode'

export default {
  name: 'QRCode',

  props: {
    width: { type: String, default: '50' },
    text: { type: String, required: true },
    margin: { type: String, default: '4' },
    small: { type: Boolean, default: false }
  },

  mounted () {
    this.doCanvas()
  },

  methods: {
    doCanvas () {
      const canvas = this.$refs.canvas
      const marginValue = parseInt(this.margin)

      QRCode.toCanvas(canvas, this.text, { width: parseInt(this.width), margin: marginValue, small: this.small }, function (error) {
        if (error) console.error(error)
      })
    }
  },

  watch: {
    text () {
      this.doCanvas()
    },
    width (newVal) {
      console.log(newVal)
      this.doCanvas()
    }
  }
}
</script>

<style lang="stylus">
</style>



// WEBPACK FOOTER //
// src/components/elements/QRCode.vue